import { useEffect, useCallback, ReactNode } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useRole, useContract } from "../ContractContext";
import { useSignatureStatus } from "../singing/SignatureStatus";
import { useForcedLoginForMembershipApp } from "../landing/LandingPage";
import { useContractUrls } from "./ContractUrls";
import { CONTRACT_PATH_ROUTES } from "./ContractPath";

export default function ContractStateRedirects({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const contract = useContract();
  const role = useRole();
  const urls = useContractUrls();
  const { otherHasSigned, isSigned, userHasSigned } = useSignatureStatus();

  const sourceForRole =
    role === contract.initiator ? contract.source : undefined;

  useForcedLoginForMembershipApp(
    sourceForRole,
    `${location.pathname}${location.search}`
  );

  const processContractState = useCallback(
    function processContractState() {
      if (
        !location.pathname.startsWith(CONTRACT_PATH_ROUTES.confirmation.path) &&
        isSigned
      ) {
        console.log(`history.replace(${urls.confirmation});`);
        history.replace(urls.confirmation);

        return;
      }

      if (
        location.pathname !== CONTRACT_PATH_ROUTES.status.path &&
        !isSigned &&
        userHasSigned &&
        !otherHasSigned
      ) {
        console.log(`history.replace(${urls.status});`);
        history.replace(urls.status);

        return;
      }

      if (
        location.pathname !== CONTRACT_PATH_ROUTES.invitation.path &&
        contract.invitation &&
        !contract.invitation.accepted &&
        contract.initiator !== role
      ) {
        console.log(`history.replace(${urls.invitation});`);
        history.replace(urls.invitation);

        return;
      }
    },
    [
      contract.initiator,
      contract.invitation,
      history,
      isSigned,
      location.pathname,
      otherHasSigned,
      role,
      urls.confirmation,
      urls.invitation,
      urls.status,
      userHasSigned,
    ]
  );

  useEffect(() => {
    processContractState();

    return history.listen(() => processContractState());
  }, [history, processContractState]);

  return <>{children}</>;
}
